/**
 * Custom Cart JS
 * - Recommendations carousel (prev/next arrows)
 * - Quick-add button for recommendations (AJAX add to cart + refresh drawer)
 */

(function () {
  'use strict';

  /* ---- Recommendations Carousel ---- */
  function initRecCarousels() {
    document.querySelectorAll('.custom-cart-rec').forEach(initRecCarousel);
  }

  function initRecCarousel(container) {
    if (container.dataset.carouselBound) return;
    container.dataset.carouselBound = '1';
    var track = container.querySelector('.custom-cart-rec__track');
    var slider = container.querySelector('.custom-cart-rec__slider');
    var prevBtn = container.querySelector('[data-dir="prev"]');
    var nextBtn = container.querySelector('[data-dir="next"]');
    if (!track || !slider) return;

    var cards = track.querySelectorAll('.custom-cart-rec__card');
    var visibleCards = 2;

    function getCardWidth() {
      if (cards.length === 0) return 0;
      var card = cards[0];
      if (card.offsetWidth <= 0) return 0;
      return card.offsetWidth + 6; // 6 = gap
    }

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = slider.scrollLeft <= 0;
      if (nextBtn) {
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        nextBtn.disabled = slider.scrollLeft >= maxScroll - 1;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var cardWidth = getCardWidth();
        if (cardWidth <= 0) return;
        slider.scrollBy({ left: -cardWidth, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var cardWidth = getCardWidth();
        if (cardWidth <= 0) return;
        slider.scrollBy({ left: cardWidth, behavior: 'smooth' });
      });
    }

    slider.addEventListener('scroll', updateArrows);
    updateArrows();

    // Mouse drag (desktop)
    var isDown = false;
    var startX, startScrollLeft;

    slider.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX;
      startScrollLeft = slider.scrollLeft;
      slider.classList.add('is-dragging');
    });
    slider.addEventListener('mouseleave', function () {
      isDown = false;
      slider.classList.remove('is-dragging');
    });
    slider.addEventListener('mouseup', function () {
      isDown = false;
      slider.classList.remove('is-dragging');
    });
    slider.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      slider.scrollLeft = startScrollLeft - (e.pageX - startX);
    });
  }

  /* ---- Quick Add Button ---- */
  function initQuickAddButtons() {
    document.querySelectorAll('.custom-cart-rec__quick-add').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', handleQuickAdd);
    });
  }

  /**
   * Get sections to render for cart drawer/page refresh
   */
  function getSectionIds() {
    var ids = ['cart-json'];
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      var sectionId = cartDrawer.getAttribute('section-id');
      if (sectionId) ids.push(sectionId);
    }
    var mainCart = document.querySelector('main-cart');
    if (mainCart) {
      var sectionId2 = mainCart.getAttribute('section-id');
      if (sectionId2) ids.push(sectionId2);
    }
    return ids;
  }

  function handleQuickAdd(e) {
    var btn = e.currentTarget;
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');

    var sectionIds = getSectionIds();

    var formData = new FormData();
    // TLB 01/10/2026 (việc 2026-10-01-sua-loi-theme-sau-soat, mục 16): gửi 1 món dạng id/quantity như form của theme.
    // Dạng items[] làm Shopify trả về thiếu item_count → số trên icon giỏ ở header thành "undefined" rồi biến mất.
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', sectionIds.join(','));
    formData.append('sections_url', window.location.pathname);

    fetch(Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/html'
      },
      body: formData
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (responseJson) {
        if (responseJson.status) {
          // Error (e.g. out of stock)
          console.error('Quick add error:', responseJson.description);
          btn.classList.remove('is-loading');
          return;
        }

        // Build cartData like theme's ProductForm does
        var cartJsonSection = responseJson.sections && responseJson.sections['cart-json'];
        var cartData = Object.assign({}, responseJson);
        if (cartJsonSection) {
          try {
            var parsed = JSON.parse(cartJsonSection.split('[split_94]')[1] || '{}');
            cartData = Object.assign(cartData, parsed);
          } catch (e) { /* ignore parse error */ }
        }

        // Dispatch cart:update event (same format as theme's ProductForm)
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            source: 'product-form',
            actionAfterATC: 'open_cart_drawer',
            variantId: variantId,
            cartData: cartData,
            formData: { id: variantId, quantity: 1 }
          }
        }));

        btn.classList.remove('is-loading');
      })
      .catch(function (err) {
        console.error('Quick add error:', err);
        btn.classList.remove('is-loading');
      });
  }

  /* ---- Bundle Discount Progress Bar Update ---- */
  function updateBundleBar(itemCount) {
    document.querySelectorAll('[data-bundle-bar]').forEach(function (bar) {
      var tiersData = bar.getAttribute('data-tiers');
      if (!tiersData) return;

      try {
        var tiers = JSON.parse(tiersData);
      } catch (e) { return; }

      tiers.sort(function (a, b) { return a.qty - b.qty; });

      var currentPercent = 0;
      var nextTier = null;
      var maxTier = tiers[tiers.length - 1];

      for (var i = 0; i < tiers.length; i++) {
        if (itemCount >= tiers[i].qty) {
          currentPercent = tiers[i].percent;
        } else if (!nextTier) {
          nextTier = tiers[i];
        }
      }

      // Calculate progress against max tier so bunny aligns with milestones
      var progressPercent = 0;
      if (itemCount >= maxTier.qty) {
        progressPercent = 100;
      } else if (maxTier.qty > 0) {
        progressPercent = Math.min(100, Math.round((itemCount / maxTier.qty) * 100));
      }

      // Update fill
      var fill = bar.querySelector('.custom-cart-progress__fill');
      if (fill) fill.style.width = progressPercent + '%';

      // Update message
      var msg = bar.querySelector('[data-bundle-message]');
      if (msg) {
        if (itemCount >= maxTier.qty) {
          msg.textContent = bar.getAttribute('data-msg-max') || 'Maximum discount unlocked!';
        } else if (nextTier) {
          var remaining = nextTier.qty - itemCount;
          var template = bar.getAttribute('data-msg-progress') || 'Buy {count} more to get {percent}% off!';
          msg.textContent = template.replace('{count}', remaining).replace('{percent}', nextTier.percent);
        }
      }

      // Update milestones
      bar.querySelectorAll('.custom-cart-progress__milestone').forEach(function (ms, idx) {
        if (idx < tiers.length && itemCount >= tiers[idx].qty) {
          ms.classList.add('is-active');
        } else {
          ms.classList.remove('is-active');
        }
      });

      bar.setAttribute('data-current-qty', itemCount);
    });
  }

  /* ---- Upsell Visibility ---- */
  function updateUpsellVisibility(totalPrice) {
    var upsell = document.getElementById('CartDrawer-upsell');
    if (!upsell) return;
    var min = parseInt(upsell.dataset.upsellMin, 10);
    if (isNaN(min) || min <= 0) {
      upsell.style.display = 'none';
      return;
    }
    upsell.style.display = totalPrice >= min ? '' : 'none';
  }

  /* ---- Init carousel khi dialog mở ---- */
  function initOnDialogOpen() {
    var dialog = document.getElementById('CartDrawer');
    if (!dialog) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'open' && dialog.hasAttribute('open')) {
          setTimeout(function () {
            initRecCarousels();
            initQuickAddButtons();
          }, 50);
        }
      });
    });
    observer.observe(dialog, { attributes: true });
  }

  /* ---- Init ---- */
  function init() {
    initRecCarousels();
    initQuickAddButtons();
    initOnDialogOpen();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify editor section events
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (section.querySelector('.custom-cart-rec')) {
      initRecCarousels();
      initQuickAddButtons();
    }
  });

  // Re-init after cart AJAX updates (theme dispatches these events)
  document.addEventListener('cart:update', function (event) {
    var cartData = event.detail && event.detail.cartData;

    // Update cart count in header "Your Cart (X)"
    if (cartData && typeof cartData.item_count !== 'undefined') {
      document.querySelectorAll('.custom-cart-count').forEach(function (el) {
        el.textContent = cartData.item_count;
      });

      // Update bundle discount progress bar
      updateBundleBar(cartData.item_count);
    }

    // Update upsell visibility based on cart total
    if (cartData && typeof cartData.total_price !== 'undefined') {
      updateUpsellVisibility(cartData.total_price);
    }

    setTimeout(function () {
      initRecCarousels();
      initQuickAddButtons();
    }, 500);
  });
})();